import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// 路由切换时滚回页面顶部；依赖 location.key，点击链接跳到当前所在页面时也会触发
const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.key]);

  return null;
};

export default ScrollToTop;
